export const CloseAccountLaterNextButton = {
  object_name: 'closeAccountLater',
  screen: 'closeAccountLater',
  screen_name: 'closeAccountLater',
  cta_title: 'Next',
}

export const CloseLaterBalanceScreenViewed = {
  event: 'screen_viewed',
  object_name: 'closeAccountLaterConfirmation',
  screen: 'closeAccountLaterConfirmation',
  screen_name: 'closeAccountLaterConfirmation',
}

export const CloseLaterBalanceScreenButtonTapped = {
  object_name: 'closeAccountLaterConfirmation',
  screen: 'closeAccountLaterConfirmation',
  screen_name: 'closeAccountLaterConfirmation',
  cta_title: 'Close account',
}

export const CloseLaterConfirmationModalTappedNevermind = {
  object_name: 'closeAccountLaterConfirmationModal',
  screen: 'closeAccountLaterConfirmation',
  screen_name: 'closeAccountLaterConfirmation',
  cta_title: 'Never mind',
}

export const CloseLaterConfirmationModalViewed = {
  event: 'screen_viewed',
  object_name: 'closeAccountLaterConfirmationModal',
  screen: 'closeAccountLaterConfirmation',
  screen_name: 'closeAccountLaterConfirmation',
}

export const CloseLaterConfirmationModalTapped = {
  object_name: 'closeAccountLaterConfirmationModal',
  screen: 'closeAccountLaterConfirmation',
  screen_name: 'closeAccountLaterConfirmation',
  cta_title: 'Close account',
}

export const CloseLaterConfirmationSuccessScreenViewed = {
  event: 'screen_viewed',
  object_name: 'closeAccountLaterDone',
  screen: 'closeAccountLaterDone',
  screen_name: 'closeAccountLaterDone',
}

export const CloseLaterConfirmationSuccessButtonTapped = {
  object_name: 'closeAccountLaterDone',
  screen: 'closeAccountLaterDone',
  screen_name: 'closeAccountLaterDone',
  cta_title: 'Done',
}
